var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImplantableOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.242,
    height: 35.625,
    viewBox: "0 0 104.242 35.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Implantable_Other",
    "data-name": "Implantable Other",
    transform: "translate(-729.234 -472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11869",
    "data-name": "Group 11869",
    transform: "translate(729.234 472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16323",
    "data-name": "Path 16323",
    d: "M8.041,0,6.37,7.473H29.653L27.976,0Z",
    transform: "translate(34.109 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11868",
    "data-name": "Group 11868",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11870",
    "data-name": "Group 11870",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16324",
    "data-name": "Path 16324",
    d: "M21.854,0c-4.76,0-9.182.845-11.68,2.23L.737,7.473H40.479L41.9,1.15,42.15,0ZM62.085,0l.261,1.15,1.417,6.323H103.5L94.068,2.23C91.571.845,87.154,0,82.388,0ZM40.346,8.611H0V32.752c.013,1.582,3.768,2.866,8.4,2.872h87.44c4.633-.006,8.388-1.29,8.4-2.872V8.611H63.9",
    fill: "#5035ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16325",
    "data-name": "Path 16325",
    d: "M6.37,7.473H29.653L27.976,0H8.041Z",
    transform: "translate(34.109 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16326",
    "data-name": "Path 16326",
    d: "M6.37,7.473H29.653L27.976,0H8.041Z",
    transform: "translate(34.109 0.001)",
    fill: "#98baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16327",
    "data-name": "Path 16327",
    d: "M29.892,1.366v9.773c-.006.318-11.769-2.809-11.769-2.809s-11.782,2.9-11.782,2.809V1.366",
    transform: "translate(33.959 6.507)",
    fill: "#98baff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11871",
    "data-name": "Group 11871",
    transform: "translate(810.514 486.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11865",
    "data-name": "Group 11865",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2743",
    "data-name": "Rectangle 2743",
    width: 15.705,
    height: 15.411,
    rx: 1,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11866",
    "data-name": "Group 11866",
    transform: "translate(2.348 2.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16297",
    "data-name": "Path 16297",
    d: "M4.251,0H0V4.251H4.251ZM3.542,3.542H.708V.708H3.542Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16298",
    "data-name": "Path 16298",
    d: "M2,2H3.417V3.417H2Z",
    transform: "translate(-0.583 -0.583)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16299",
    "data-name": "Path 16299",
    d: "M0,14.251H4.251V10H0Zm.708-3.542H3.542v2.834H.708Z",
    transform: "translate(0 -2.915)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16300",
    "data-name": "Path 16300",
    d: "M2,12H3.417v1.417H2Z",
    transform: "translate(-0.583 -3.498)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16301",
    "data-name": "Path 16301",
    d: "M10,0V4.251h4.251V0Zm3.542,3.542H10.708V.708h2.834Z",
    transform: "translate(-2.915)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16302",
    "data-name": "Path 16302",
    d: "M12,2h1.417V3.417H12Z",
    transform: "translate(-3.498 -0.583)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16303",
    "data-name": "Path 16303",
    d: "M1.417,7H0V8.417H2.125V7.708H1.417Z",
    transform: "translate(0 -2.041)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16304",
    "data-name": "Path 16304",
    d: "M7,9H8.417v1.417H7Z",
    transform: "translate(-2.041 -2.624)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16305",
    "data-name": "Path 16305",
    d: "M3,7H4.417v.708H3Z",
    transform: "translate(-0.875 -2.041)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16306",
    "data-name": "Path 16306",
    d: "M8.417,12H7v.708h.708v.708h.708V12Z",
    transform: "translate(-2.041 -3.498)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16307",
    "data-name": "Path 16307",
    d: "M5.708,7v.708H5v.708H6.417V7Z",
    transform: "translate(-1.458 -2.041)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16308",
    "data-name": "Path 16308",
    d: "M8,4h.708V5.417H8Z",
    transform: "translate(-2.332 -1.166)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16309",
    "data-name": "Path 16309",
    d: "M8.708,7.708v.708h1.417V7H8v.708Z",
    transform: "translate(-2.332 -2.041)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16310",
    "data-name": "Path 16310",
    d: "M7,6h.708v.708H7Z",
    transform: "translate(-2.041 -1.749)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16311",
    "data-name": "Path 16311",
    d: "M9,14h1.417v1.417H9Z",
    transform: "translate(-2.624 -4.081)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16312",
    "data-name": "Path 16312",
    d: "M7,14h.708v1.417H7Z",
    transform: "translate(-2.041 -4.081)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16313",
    "data-name": "Path 16313",
    d: "M9,11h.708v.708H9Z",
    transform: "translate(-2.624 -3.207)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16314",
    "data-name": "Path 16314",
    d: "M8.417,2.125V.708H7.708V0H7V2.834h.708V2.125Z",
    transform: "translate(-2.041)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16315",
    "data-name": "Path 16315",
    d: "M12,14h.708v1.417H12Z",
    transform: "translate(-3.498 -4.081)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16316",
    "data-name": "Path 16316",
    d: "M12,12h1.417v.708H12Z",
    transform: "translate(-3.498 -3.498)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16317",
    "data-name": "Path 16317",
    d: "M11,13h.708v.708H11Z",
    transform: "translate(-3.207 -3.79)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16318",
    "data-name": "Path 16318",
    d: "M10,12h.708v.708H10Z",
    transform: "translate(-2.915 -3.498)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16319",
    "data-name": "Path 16319",
    d: "M14,10v.708h.708v.708h.708V10H14Z",
    transform: "translate(-4.081 -2.915)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16320",
    "data-name": "Path 16320",
    d: "M14.708,13H14v2.125h1.417V13.708h-.708Z",
    transform: "translate(-4.081 -3.79)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16321",
    "data-name": "Path 16321",
    d: "M10,9.708v.708h2.125V9H10.708v.708Z",
    transform: "translate(-2.915 -2.624)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16322",
    "data-name": "Path 16322",
    d: "M12,7v.708h1.417v.708h1.417V7H12Z",
    transform: "translate(-3.498 -2.041)",
    fill: "#444"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplantableOther);
export default __webpack_public_path__ + "static/media/ImplantableOther.15a8c3e1a8b82e14d99b9578be499979.svg";
export { ForwardRef as ReactComponent };